"use strict";
// Because IE doesn't support Array.prototype.find :(
Object.defineProperty(exports, "__esModule", { value: true });
function findFirst(array, predicate) {
    for (const item of array) {
        if (predicate(item)) {
            return item;
        }
    }
    return undefined;
}
exports.default = findFirst;
